export interface ParceiroDeNegocio   {
  CFILIAL: string;
  CCODIGO: string;
  CLOJA: string;
  CNOME: string;
  CCGC: string;
  CNREDUZ: string;
  DULTCOM: Date | undefined;
  DATUSINTEGRA: Date | undefined;
  DATURECEITA: Date | undefined;
  CTIPO: 'C' | 'F';
  NRECNO: number;
}


export interface ParceiroDeNegocioDto {
  items: Array<ParceiroDeNegocio>;
}

export interface SimplesNacional {
  nomeEmpresarial                   : string;
  situacaoSimplesNacional           : string;
  situacaoSimei                     : string;
  simplesNacionalPeriodosAnteriores : string;
  SIMEIPeriodosAnteriores           : string;
  urlComprovante                    : string;
}


export interface SintegraInscricoesEstaduais {
  cpf: string;
  cnpj: string;
  inscricaoEstadual: string;
  razaoSocial: string;
  nomeFantasia: string;
  logradouro: string;
  numero: string;
  complemento: string;
  bairro: string;
  cep: string;
  municipio: string;
  uf: string;
  telefone: string;
  atividadeEconomica: string;
  atividadesEconomicasSecundarias: Array<string>;
  dataInicioAtividade: string;
  dataSituacaoCadastral: string;
  regimeRecolhimento: string;
  observacao: string;
  situacaoCadastral: string;
  situacaoCadastralTratada: number;
  ocorrenciaFiscal: string;
  atividadeEconomicaTratada: string;
  atividadesEconomicasSecundariasTratada: Array<string>;
  urlComprovante: string;
}

export interface Sintegra {
  inscricoesEstaduais: Array<SintegraInscricoesEstaduais>;
}


export interface ParceiroDeNegocioAtualizar {
  LCONSULTARECEITA: boolean;
  LCONSULTASINTEGRA: boolean;
  LCONSULTASIMPLES: boolean;
  AITENS: Array<ParceiroDeNegocio>;
}

export const defaultParceiroDeNegocioAtualizar = (): ParceiroDeNegocioAtualizar => ({
  LCONSULTARECEITA: true,
  LCONSULTASINTEGRA: true,
  LCONSULTASIMPLES: true,
  AITENS: []
});

export interface ReceitaFederal {
  cnpj                  : string;
  razaoSocial           : string;
  nomeFantasia          : string;
  naturezaJuridica      : string;
  logradouro            : string;
  numero                : string;
  complemento           : string;
  bairro                : string;
  municipio             : string;
  cep                   : string;
  uf                    : string;
  email                 : string;
  telefone              : string;
  efr                   : string;
  situacaoCadastral     : string;
  dataSituacaocadastral : string;
  dataInicioAtividade   : string;
  atividadeEconomica    : string;
  tipoCNPJ              : string;
  situacaoEspecial      : string;
  dataSituacaoEspecial  : string;
  motivoSituacao        : string;
  porte                 : string;
  urlComprovante        : string;
  atividadesEconomicasSecundarias: Array<string>;

}

export interface DadosFiscais {
  cnpj            : string;
  receitaFederal  : ReceitaFederal | undefined;
  simplesNacional : SimplesNacional | undefined;
  sintegra        : Sintegra | undefined;
  dataHora        : Date;
}


export const getDefaultDadosFiscais = (): DadosFiscais => ({
  cnpj: '',
  receitaFederal  : undefined,
  simplesNacional : undefined,
  sintegra        : undefined,
  dataHora        : new Date()
});


export interface IntegracaoNetrin {
  [key:string]            : string | number | undefined | Date | DadosFiscais | Object;
  $selected               :  boolean;
  NID                     :  number;
  CTEMPRESA               :  string;
  CTFILIAL                :  string;
  CTIPO                   :  string;
  CCODIGO                 :  string;
  CLOJA                   :  string;
  CCGC                    :  string;
  CJAINCLUIDO             :  string;
  CSTATUS                 :  string;
  CMENSAGEMERRO           :  string;
  DDATAINCLUSAO           :  Date | undefined;
  DDATAATULIZACAOS        :  Date | undefined;
  OJSONDADOS              :  DadosFiscais;
  OJSONERRO               :  Object | undefined;

  CNOME                   :  string;
  CNOMEFANTASIA           :  string;
  CEND                    : string;
  CCOMPLEM                : string;
  CMUN                    : string;
  CSIMPNAC                : '1'|'2'|' ';
  CINSCR                  : string;
  CATIVO                  : string;
  CCEP                    : string;
  NRECNO                  : number;
  LANALISADO              : boolean;
  LNOME                   : boolean;
  LNOMEFANTASIA           : boolean;
  LEND                    : boolean;
  LCOMPLEM                : boolean;
  LMUN                    : boolean;
  LSIMPNAC                : boolean;
  LINSCR                  : boolean;
  LCEP                    : boolean;
  CCOMANALISE             : string;
}



export const defaultReceitaFederal = (): ReceitaFederal => ({
  cnpj                  : '',
  razaoSocial           : '',
  nomeFantasia          : '',
  naturezaJuridica      : '',
  logradouro            : '',
  numero                : '',
  complemento           : '',
  bairro                : '',
  municipio             : '',
  cep                   : '',
  uf                    : '',
  email                 : '',
  telefone              : '',
  efr                   : '',
  situacaoCadastral     : '',
  dataSituacaocadastral : '',
  dataInicioAtividade   : '',
  atividadeEconomica    : '',
  tipoCNPJ              : '',
  situacaoEspecial      : '',
  dataSituacaoEspecial  : '',
  motivoSituacao        : '',
  porte                 : '',
  urlComprovante        : '',
  atividadesEconomicasSecundarias: []
});


export const defaultIntegracaoNetrin = (): IntegracaoNetrin => ({
  $selected: false,
  NID: 0,
  CTEMPRESA: '',
  CTFILIAL: '',
  CTIPO: '',
  CCODIGO: '',
  CLOJA: '',
  CCGC: '',
  CJAINCLUIDO: '',
  CSTATUS: '',
  CMENSAGEMERRO: '',
  DDATAINCLUSAO: undefined,
  DDATAATULIZACAOS: undefined,
  OJSONDADOS: getDefaultDadosFiscais(),
  OJSONERRO: undefined,

  CNOME: '',
  CNOMEFANTASIA: '',
  CEND: '',
  CCOMPLEM: '',
  CMUN: '',
  CSIMPNAC: ' ',
  CINSCR: '',
  CCEP: '',

  LANALISADO: false,
  LNOME: true,
  LNOMEFANTASIA: true,
  LEND: true,
  LCOMPLEM: true,
  LMUN: true,
  LSIMPNAC: true,
  LINSCR: true,
  LCEP: true,
  CCOMANALISE: ' ',

  CATIVO: '',
  NRECNO: 0
})

export interface IntegracaoNetrinDto {
  items: Array<IntegracaoNetrin>;
}


